import { Injectable } from '@angular/core'
import { FLAGS_KEY } from '@constants/preferences-keys.constant'
import { FeatureFlags, Flags } from '@interfaces/flags.interface'
import { LocalStorageService } from '@services/local-storage/local-storage.service'

@Injectable({
  providedIn: 'root'
})
export class FlagsService {
  private defaultFlags: Flags = {
    EXPORTS_DONT_SHOW_DOWNLOAD_ONLY_VISIBLE_ITEMS_WARNING_ANYMORE: false,
    PENDENCY_DETAILS_DONT_SHOW_TRANSFER_PENDENCY_WARNING_ANYMORE: false
  }

  public constructor (
    private readonly localStorageService: LocalStorageService
  ) { }

  public getFlag(featureFlag: FeatureFlags): boolean {
    const flags = this.localStorageService.get<Flags>(FLAGS_KEY)
    if (!flags) { return false }

    return flags[featureFlag]
  }

  public setFlag(featureFlag: FeatureFlags, value: boolean) {
    let flags = this.localStorageService.get<Flags>(FLAGS_KEY)
    if (!flags) {
      flags = this.defaultFlags
    }

    flags[featureFlag] = value

    this.localStorageService.set(FLAGS_KEY, flags)
  }
}
